import React, { useState, Suspense, useEffect } from "react";
import clsx from 'clsx';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { useUserDispatch, signOut } from "../../context/UserContext";
import { Dropdown, Menu } from 'antd';
import { Route, Switch, Redirect, useLocation, NavLink, useHistory } from "react-router-dom";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {
    Drawer, Badge,
    Box, AppBar,
    Toolbar, List,
    IconButton, Tooltip, ListItem, Button,
    Collapse, Grid,
} from "@material-ui/core";
import Popover from '@material-ui/core/Popover';
import AddIcon from '@material-ui/icons/Add';
import Chat from "../../assets/img/mobile/chat.svg";
import User from "../../assets/img/mobile/user.svg";
import Bag from "../../assets/img/mobile/bag.svg";
import Packages from "../../assets/img/mobile/packages.svg";
import HomeIcon from "../../assets/img/mobile/home-svg.svg";
import MobNotification from "../../assets/img/mobile/Mobnotification.svg";
import { styled } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import CloseIcon from '@material-ui/icons/Close';
import Dashboard from './../../pages/dashboard/Dashboard';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuIcon from '@material-ui/icons/Menu';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import MenuMobile from "../../assets/img/mobile/menu.svg";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MessagesIcon from '../../assets/img/icons/Messages.svg';
import profilePlaceholder from '../../assets/img/profilePlaceholder.jpg';
// import DashboardIcon from '@material-ui/icons/Dashboard';
// import Logo from '../../assets/img/logo.svg';
import Logo from '../../assets/img/nav/nav-app-logo.svg';
import Notification from '../../assets/img/icons/Notification.svg';
import LogoSm from '../../assets/img/logo-sm.svg';
import SettingsIcon from '../../assets/img/icons/setting.svg';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Communication from '../../pages/communication/Communication';
import DigitalServices from '../../pages/digitalServices/DigitalServices';
import AddressBook from "../../pages/addressbook/AddressBook";
import PaymentHistory from "../../pages/paymentHistory/PaymentHistory";
import AccountSettings from "../../pages/accountSettings/AccountSettings";
import UserProfile from "../../pages/profile/Profile";
import AccountSettingsIcon from '../../assets/img/nav/nav-account-settings-icon.svg';
import AddressBookIcon from '../../assets/img/nav/nav-address-book-icon.svg';
import CommunicationIcon from '../../assets/img/nav/nav-communnication-icon.svg';
import DamageRepairsIcon from '../../assets/img/nav/nav-damage-repairs-icon.svg';
import DashboardNavIcon from '../../assets/img/nav/nav-dashboard-icon.svg';
import DevicesIcon from '../../assets/img/nav/nav-devices-icon.svg';
import DigitalServiceIcon from '../../assets/img/nav/nav-digital-service-icon.svg';
import HistoryIcon from '../../assets/img/nav/nav-history-icon.svg';
import MyAccountIcon from '../../assets/img/nav/nav-my-account-icon.svg';
// import Icon from '../../assets/img/nav/nav-my-account-icon.svg'
import OffersIcon from '../../assets/img/nav/nav-offers-icon.svg';
import { PostDataAPI } from '../../Services/APIService';
import { GetUserInfo } from '../../../src/Services/GetUserInfo';
import LineManagement from '../../pages/lineManagement/LineManagement';
import { GetUserRolesRights } from '../../Services/GetUserRolesRights';
import MessageDialog from './../../components/MessageDialog/MessageDialog';
import WarningRedTrasp from './../../assets/img/icons/warning-sign-transp.svg';
import LinemangementIcon from "../../assets/img/icons/lineManagement1.svg";
import PaymentHistoryIcon from "../../assets/img/icons/Paymenticon1.svg";
import CorporateDashboard from "../../pages/corporateDashboard/corporateDashboard";
import ActivityMonitoring from "../../pages/activityMonitoring/ActivityMonitoring";
import useStyles from "./styles";
import Settingwhite from '../../assets/img/icons/settingwhite.svg';
import Settingblue from '../../assets/img/icons/setting2x.svg';
import AccountDetail from '../../assets/img/icons/accountdetail.svg';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import RolesIcon from "../../assets/img/icons/roles.svg";
import UsersIcon from "../../assets/img/icons/users.svg";
import Users from "./../../pages/setup/users/users";
import Roles from "./../../pages/setup/roles/Roles";
import { useSignalR } from '../../Services/SignalRContext';
import { withSnackbar } from "./../../components/Message/Alert";
import ActivityMonitoringIcon from "../../assets/img/icons/activeLog.svg";

function Layout(props) {

    const location = useLocation();
    const HomeHistory = useHistory();
    const { showMessage } = props;
    var user = sessionStorage.getItem('user_info');
    const [userInfo, setUserInfo] = useState(sessionStorage.getItem('user_info'));
    var userdata = JSON.parse(user).user;
    const [counter, setCounter] = useState(0);

    var userDispatch = useUserDispatch();
    const classes = useStyles();
    const [historySubMenuOpen, setHistorySubMenuOpen] = React.useState(false);
    const [offereSubMenuOpen, setOffersSubMenuOpen] = React.useState(false);
    const [subMenuOpen, setSubMenuOpen] = React.useState(false);
    const signalRService = useSignalR();
    //signalR 
    const [userStatus, setuserStatus] = useState([]);

    //signalR
    const [loading, setLoading] = React.useState(true);

    const historyClick = () => setHistorySubMenuOpen(!historySubMenuOpen);
    const offersClick = () => setOffersSubMenuOpen(!offereSubMenuOpen);


    const [anchorEl, setAnchorEl] = React.useState(null);
    const openPoper = Boolean(anchorEl);
    const id = openPoper ? 'simple-popover' : undefined;


    const poperOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClick = () => {

        if (subMenuOpen == true) {
            setSubMenuOpen(false);
        } else {
            setSubMenuOpen(true);
        }

    };
    const poperClose = () => {
        setAnchorEl(null);
    };
    const StyledFab = styled(Fab)({
        position: 'absolute',
        zIndex: 1,
        top: -30,
        left: 0,
        right: 0,
        margin: '0 auto',
    });
    const [open, setOpen] = React.useState(window.isIpadView ? false : true);
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    const counterGet = () => {
        user = sessionStorage.getItem('user_info');
        setUserInfo(sessionStorage.getItem('user_info'));
        userdata = JSON.parse(user).user;
        var params = {
            code: "unread_chat_count",
            parameters: [userdata.userId]
        };

        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null) {

                setCounter(result.data[0].t1 ? parseInt(result.data[0].t1) : 0)
                var ui = GetUserInfo();
                if (ui)
                    startCounter();
            }
        })
    }


    const [messageDialog, setMessageDialog] = useState(false);


    const closeMessage = () => {
        signOut(userDispatch, props.history)
        setMessageDialog(false)
    }
    // implementing for forcelogout functionallity 
    const getuserstatus = () => {
        let data = {
            userID: userdata.userId
        }
        PostDataAPI("auth/getstatus", data).then((result) => {
            if (result.success && result.data != null) {
                if (result.data.status === 0 || result.data.status === null) {
                    setMessageDialog(true);
                }
            } else {
            }
        });
    }
    //setInterval(getuserstatus, 600000);
    const getProfileDetails = () => {
        var params = {
            code: "unread_chat_count",
            parameters: [userdata.userId]
        };

        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null) {
                setCounter(result.data[0].t1 ? parseInt(result.data[0].t1) : 0)
                var ui = GetUserInfo();
                if (ui)
                    startCounter();
            }
        })
    }
    const [menusState, setMenusState] = React.useState([]);
    const [disabledChildren, setDisabledChildren] = React.useState([]);
    const [hiddenChildren, setHiddenChildren] = React.useState([]);
    const [anchorE1, setAnchorE1] = React.useState(null);
    const [popoverState, setPopoverState] = useState(null);
    const isPopoverOpen1 = Boolean(anchorE1);
    //side bar start
    const sideBarLinks = [];
    const mobileLinks = [];
    const routes = [];
    let user_role_rights_list = JSON.parse(GetUserRolesRights());
    let user_info = JSON.parse(GetUserInfo());
    if (user_role_rights_list != null) {
        user_role_rights_list.map((objright) => {
            if (objright.permissionCode > 0) {
                routes.push({ rightName: objright.rightName, permissionCode: objright.permissionCode, landingPage: objright.landingPage });
            }
            if (objright.parentRightId == 0 && objright.permissionCode > 0) {

                switch (objright.rightName) {

                    case 'dashboard': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: user_info.user.userType == 'corporate_user' ? 'Account Summary' : objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={AccountDetail} alt='icon' />,
                                category: objright.category,
                            });

                        }
                        break;
                    }
                    case 'corporateDashboard': {
                        if (sideBarLinks.label != objright.rightName && user_info.user.userType == 'corporate_user') {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={DashboardNavIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'profile': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={MyAccountIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'payment-history': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={PaymentHistoryIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'lineManagement': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={LinemangementIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'activity-monitoring': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel || 'Activity Monitoring',
                                link: "/app/activity-monitoring",
                                icon: <img src={ActivityMonitoringIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'address-book': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={AddressBookIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'digital-Services': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={DigitalServiceIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'communication': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={CommunicationIcon} alt='icon' />,
                                category: objright.category,

                            });
                        }
                        break;
                    }
                    case 'devices': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={DevicesIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'offers': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={OffersIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'damage-and-repairs': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={DamageRepairsIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'account-settings': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={AccountSettingsIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'Setup': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName,
                                icon: <img src={Settingblue} alt='setup' />,
                                category: objright.category,
                                children: [
                                    { label: "Roles", link: "/app/customerRoles", icon: <img src={RolesIcon} alt='icon' /> },
                                    { label: "Users", link: "/app/users", icon: <img src={UsersIcon} alt='icon' /> },
                                ],
                            });
                        }
                        break;
                    }
                    case 'userGuide': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/Corporate_portal.html",
                                icon: <HelpOutlineIcon />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    default:
                        break;
                }
            }
        });
    }

    if (!sideBarLinks.some(link => link.link === "/app/activity-monitoring")) {
        sideBarLinks.push({
            id: 9001,
            label: 'Activity Monitoring',
            link: "/app/activity-monitoring",
            icon: <img src={ActivityMonitoringIcon} alt='icon' />,
            category: 'activity',
        });
    }


    const hasAccessTo = (label) => {
        return sideBarLinks.some(link => link.label === label);
    };


    const startCounter = () => { setTimeout(function () { counterGet(); }, 9000); }
    const handleClickMenu = (name, hasChildren) => {
        const updatedMenu = menusState.map(obj => {
            if (obj.name === name) {
                return { ...obj, value: !obj.value }; // Toggle the value
            }
            return { ...obj, value: false };
        });
        setMenusState(updatedMenu);
        if (window.isIpadView && !hasChildren) {
            handleDrawerClose();
        }

    }
    const handleChildMenuClick = () => {
        if (window.isIpadView) {
            setOpen(false);
        }
    }
    const handlePopoverOpen1 = (event, index) => {
        setAnchorE1(event.currentTarget);
        setPopoverState(index)
    };
    const handlePopoverClose1 = (event) => {
        setAnchorE1(null);
    };

    const handleMessage = (message) => {
        if (message != null && typeof message === 'string' && message.includes(sessionStorage.getItem('signalRConnectionId'))) {
            if (message.includes("syncingstarted")) {
                //showMessage("Success", "Line refresh started.", "success", 3000);
            }
            else if (message.includes('syncingfinish')) {

                showMessage("Success", "Line refresh completed, reloading lines.", "success", 3000);
                sessionStorage.setItem('isLineSyncing', 'false')

            }
            else if (message.includes('syncingfailed')) {
                showMessage("Error", "Unable to refresh lines at the moment. Please try again in a few minutes.", "error", 3000);
                sessionStorage.setItem('isLineSyncing', 'false')

            }
        }
    };

    useEffect(() => {
        debugger
        signalRService.subscribeToMessages(handleMessage);

        return () => {
            signalRService.unsubscribeFromMessages(handleMessage);
        };

    }, [signalRService]);
    useEffect(() => {

        //For signalR Will be implemented later
        //// Establish SignalR connection
        //const connection = new signalR.HubConnectionBuilder()
        //    .withUrl("http://localhost:3000/#/app/corporateManagement/hub/coporateuserhub") // Provide the URL of your SignalR hub
        //    .build();

        //// Define event handler for "UserDeactivated"
        //connection.on("UserDeactivated", (userId) => {
        //    alert("im here")
        //    // Trigger sign-out function for the user with userId
        //    signOut(userDispatch, props.history)
        //});

        //// Start the connection
        //connection.start()
        //    .then(() => {
        //        console.log("SignalR connection established.");
        //    })
        //    .catch((error) => {
        //        console.error("Error establishing SignalR connection:", error);
        //    });

        //// Cleanup function to stop the connection when component unmounts
        //return () => {
        //    connection.stop();
        //};



        user_role_rights_list?.forEach((objright) => {
            if (objright.parentRightId === 0 && objright.permissionCode > 0) {
                menusState.push({ name: objright.rightLabel, value: false });
            }
            if (objright.category === 'disabled' && objright.parentRightId > 0) {
                disabledChildren.push(objright.rightLabel);
            }
            if (objright.permissionCode == 0 && objright.parentRightId > 0) {
                hiddenChildren.push(objright.rightLabel);
            }
        });
        counterGet()
        setLoading(true)
        setTimeout(() => {
            setLoading(false);
        }, 500);

    }, []);

    return (
        <div className={classes.root}>
            {messageDialog ? <MessageDialog icon={WarningRedTrasp} iconSize={"70px"} messageText="You Have been Logged Out" openMessage={messageDialog} closeMessage={closeMessage}></MessageDialog> : ''}
            {window.isIpadView ?
                <div className={classes.topMobile}>
                    <AppBar position="absolute">
                        <Toolbar className={classes.toolbarMobile} >
                            <Grid container alignItems="center">
                                <Grid item xs={4} sm={4} md={4} lg={4}>
                                    <img src={MenuMobile} alt="" onClick={handleDrawerOpen} />
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} lg={4} className="textCenter">
                                    <img src={Logo} alt="" className={classes.mobileLogo} />
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} lg={4} className="textRight">

                                    <Dropdown overlay={<Menu>
                                        <Menu.Item
                                            className={classes.DropdownItems}>
                                            <NavLink to="/app/profile" >  <PersonOutlineIcon /> Profile </NavLink>
                                        </Menu.Item>

                                        <Menu.Item
                                            onClick={() => signOut(userDispatch, props.history)} className={classes.DropdownItems}>  <ExitToAppIcon /> Logout
                                        </Menu.Item>




                                    </Menu>} trigger={["click"]}
                                        className={classes.actionDropDown}>

                                        <Button className={classes.profileDropper}>
                                            <ArrowDropDownIcon />
                                            <img className="profile-icon" src={userdata.userPhotoPath ? '.' + userdata.userPhotoPath : profilePlaceholder} />



                                        </Button>
                                    </Dropdown>
                                </Grid>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                </div>
                :
                <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                    <Toolbar className={classes.toolbar}>
                        {open ? <div className={classes.toolbarIcon}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerClose}
                                className={classes.menuButton}
                            >
                                <MenuIcon />
                            </IconButton>
                        </div> : <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            className={classes.menuButton}>
                            <MenuIcon />
                        </IconButton>
                        }

                        <div className={classes.rightContent}>

                            {
                                user_role_rights_list.some(item => item.rightName === 'communication' && item.permissionCode > 0) ?
                                    <NavLink to="/app/communication">
                                        <IconButton color="inherit">
                                            <Badge badgeContent={counter} color="secondary">
                                                <img src={MessagesIcon} />
                                            </Badge>
                                        </IconButton>
                                    </NavLink>
                                    : ''}
                            {/*<IconButton color="inherit">*/}
                            {/*    <Badge badgeContent={4} color="secondary">*/}
                            {/*        <img src={Notification} />*/}
                            {/*    </Badge>*/}
                            {/*</IconButton>*/}
                            {/*<IconButton color="inherit">*/}
                            {/*    <img src={SettingsIcon} />*/}

                            {/*</IconButton>*/}

                            <Dropdown overlay={<Menu>
                                <Menu.Item
                                    className={classes.DropdownItems}>
                                    <NavLink to="/app/profile" >  <PersonOutlineIcon /> Profile </NavLink>
                                </Menu.Item>

                                <Menu.Item
                                    onClick={() => signOut(userDispatch, props.history)} className={classes.DropdownItems}>  <ExitToAppIcon /> Logout
                                </Menu.Item>
                            </Menu>} trigger={["click"]}
                                className={classes.actionDropDown}>

                                <Button className={classes.profileDropper}>
                                    <img className="profile-icon" src={userdata.userPhotoPath ? '.' + userdata.userPhotoPath : profilePlaceholder} />

                                    <h4>{userdata != null ? userdata.firstName : "Melvin B. Price Static"}</h4>
                                    <ArrowDropDownIcon />

                                </Button>
                            </Dropdown>

                        </div>

                    </Toolbar>
                </AppBar>}
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open ? classes.drawerPaperClose : ''),
                }}
                open={open}
            >
                <div className={open ? classes.logo : classes.logoSm}>
                    {open ? (
                        <img
                            onClick={() => HomeHistory.push("/app/" + (routes[0]?.landingPage ? routes[0]?.landingPage : "dashboard"))}
                            src={Logo}
                            alt=""
                        />
                    ) : (
                        <img
                            onClick={() => HomeHistory.push("/app/" + (routes[0]?.landingPage ? routes[0]?.landingPage : "dashboard"))}
                            width="34px"
                            src={LogoSm}
                            alt=""
                        />
                    )}
                    {window.isIpadView ?
                        <CloseIcon className={classes.mobileCloseIco} onClick={handleDrawerClose} /> : ''
                    }

                </div>
                <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    className={classes.menuList}>
                    {sideBarLinks.map((link, index) => (

                        <div className={menusState.some(item => item.value && item.name === link.label) && link.children ? classes.openHasSubmenu : classes.hasSubmenu}>
                            <Tooltip title={open ? '' : link.label} placement="right" className={link.category === "disabled" ? "disabledEvent" : ''}>
                                <ListItem onClick={open ? () => handleClickMenu(link.label, link.children ? link.children : '') : (e) => handlePopoverOpen1(e, index)}>
                                    {link.children ? (
                                        <div className={classes.subMenuHead + ' whiteMenuIcon'}>
                                            {link.icon} <span className={classes.MenuLabel}>{link.label} {link.children ? (
                                                <>
                                                    {menusState.some((item) => item.value && item.name === link.label) ? <ExpandLess /> : <ExpandMore />}
                                                </>
                                            ) : ''} </span>
                                        </div>
                                    ) : (
                                        <>


                                            {link.label == 'User Guide' ?
                                                <a style={{ cursor: 'pointer' }} target="_blank" href='/Corporate_portal.html' ><HelpOutlineIcon /> <span className={classes.MenuLabelUser}>  User Guide</span></a>
                                                :
                                                <ListItem className={`${link.label !== 'Dashboard' && link.label !== 'Payment History' && link.label !== 'Line Management' && link.label !== 'Account Summary' && link.label !== 'Activity Monitoring' ? '' : "whiteMenuIcon"} ${disabledChildren.includes(link.label) ? ' disabledEvent' : ''}`}>
                                                    <NavLink to={link.link} ><span>{link.icon}</span><span className={classes.MenuLabel}>  {link.label}</span></NavLink>
                                                </ListItem>
                                            }

                                        </>
                                    )}
                                </ListItem>
                            </Tooltip>
                            {open && link.children ?
                                <Collapse in={menusState.some(item => item.value && item.name === link.label)} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {link.children.filter(child => !hiddenChildren.includes(child.label)).map(child => (
                                            <>
                                                <ListItem onClick={() => handleChildMenuClick()} >
                                                    <NavLink to={child.link} ><span>{child.icon}</span><span className={classes.MenuLabel}>  {child.label}</span></NavLink>
                                                </ListItem>
                                            </>
                                        ))}

                                    </List>
                                </Collapse> :
                                link.children && link.children.length > 0 ?
                                    <>
                                        <div className={classes.menuPoper}>
                                            <Popover
                                                id={id}
                                                open={isPopoverOpen1 && popoverState == index}
                                                anchorEl={anchorE1}
                                                onClose={handlePopoverClose1}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'center',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <List component="div" disablePadding>
                                                    {link.children.filter(child => !hiddenChildren.includes(child.label)).map(child => (
                                                        <ListItem className={`${classes.popperSub} ${disabledChildren.includes(child.label) ? ' disabledEvent' : ''}`}>
                                                            <NavLink to={child.link}>{child.icon} <span className={classes.MenuLabel}>{child.label}</span></NavLink>
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </Popover>
                                        </div>
                                    </> :
                                    ''
                            }
                        </div>
                    ))}


                    {/* <a style={{ cursor: 'pointer' }} target="_blank" href='/Corporate_portal.html' ><HelpOutlineIcon /> <span className={classes.MenuLabelUser}>  User Guide</span></a> */}

                </List>
            </Drawer>
            <main className="theme-container">
                <Suspense fallback={<Box style={{ display: 'block', width: '100%', textAlign: "center", paddingTop: "10%" }}><CircularProgress /></Box>}>
                    <Switch>
                        {/* <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
                        <Route exact path="/app" render={() => <Redirect to="/app/dashboard" />} /> */}
                        <Route exact path="/" render={() => <Redirect to={"/app/" + routes[0]?.landingPage ? routes[0]?.landingPage : 'dashboard'} />} />

                        <Route exact path="/app" render={() => <Redirect to={"/app/" + routes[0]?.landingPage ? routes[0]?.landingPage : 'dashboard'} />} />


                        {/*{routes.some(route => route === 'dashboard') && <Route path="/app/dashboard" component={Dashboard} />}*/}
                        {/*{routes.some(route => route.rightName === 'dashboard') && <Route path="/app/dashboard" render={() => <Dashboard permissionCode={0} />} />}*/}
                        {routes.some(route => route.rightName === 'dashboard') && (
                            <Route
                                path="/app/dashboard"
                                render={() => {
                                    const dashboardRoute = routes.find(route => route.rightName === 'dashboard');
                                    return <Dashboard accessableRouts={routes} />;
                                }}
                            />
                        )}
                        {routes.some(route => route.rightName === 'corporateDashboard') && <Route path="/app/corporateDashboard" component={CorporateDashboard} />}
                        {routes.some(route => route.rightName === 'dashboard') && <Route path="/app/dashboard" component={Dashboard} />}
                        {routes.some(route => route.rightName === 'communication') && <Route path="/app/communication" component={Communication} />}
                        {routes.some(route => route.rightName === 'digital-Services') && <Route path="/app/digital-Services" component={DigitalServices} />}
                        {routes.some(route => route.rightName === 'address-book') && <Route path="/app/address-book" component={AddressBook} />}
                        {routes.some(route => route.rightName === 'payment-history') && <Route path="/app/payment-history" component={PaymentHistory} />}
                        {routes.some(route => route.rightName === 'account-settings') && <Route path="/app/account-settings" component={AccountSettings} />}
                        {routes.some(route => route.rightName === 'profile') && <Route path="/app/profile" component={UserProfile} />}
                        {routes.some(route => route.rightName === 'lineManagement') && <Route path="/app/lineManagement" component={LineManagement} />}
                        <Route path="/app/activity-monitoring" component={ActivityMonitoring} />
                        {/*{routes.some(route => route.rightName === 'notificationList') && <Route path="/app/notificationList" component={NotificationContactList} />}*/}
                        {routes.some(route => route.rightName === 'customerRoles') && <Route path="/app/customerRoles" render={() => <Roles roleType={'customer_portal'}></Roles>} />}
                        {routes.some(route => route.rightName === 'users') && <Route path="/app/users" component={Users} />}
                        <Route path="/app/profile" component={UserProfile} />

                        {/*<Route path="/app/corporateDashboard" component={CorporateDashboard} />*/}
                    </Switch>
                </Suspense>
            </main>
            {window.isIpadView && location.pathname !== "/app/communication" ?
                <div className={classes.bottomFooter}>
                    <AppBar position="fixed" color="primary" sx={{ top: 'auto', bottom: 0 }}>
                        <Toolbar className={classes.justifyIcons}>
                            <IconButton color="inherit" className={hasAccessTo('Account Summary') || hasAccessTo('Dashboard') ? '' : classes.DisableButton}>
                                <NavLink to={hasAccessTo('Account Summary') || hasAccessTo('Dashboard') ? hasAccessTo('Dashboard') ? "/app/corporateDashboard" : "/app/dashboard" : '#'}>
                                    <img style={{ width: '25px' }} src={HomeIcon} />
                                    {window.isMobile425 ? '' : <p> Home </p>}
                                </NavLink>

                            </IconButton>
                            <IconButton color="inherit" className={hasAccessTo('Notify Contacts') ? '' : classes.DisableButton}>
                                <NavLink to={hasAccessTo('Address Book') ? "/app/address-book" : '#'}>
                                    <img src={AddressBookIcon} />
                                    {window.isMobile425 ? '' :
                                        <p> Notify Contacts </p>
                                    }
                                </NavLink>
                            </IconButton>
                            {
                                user_role_rights_list.some(item => item.rightName === 'communication' && item.permissionCode > 0) ? <StyledFab color="secondary" className={classes.fabStyle} aria-label="add">
                                    <NavLink to="/app/communication">  <img src={Chat} /> </NavLink>
                                </StyledFab>
                                    : ''}

                            {window.isMobile425 ? <Box sx={{ flexGrow: 1 }} /> : ''}
                            <IconButton color="inherit" className={hasAccessTo('Payment History') ? '' : classes.DisableButton}>
                                <NavLink to={hasAccessTo('Payment History') ? "/app/payment-history" : '#'}>
                                    <img src={PaymentHistoryIcon} style={{ filter: 'brightness(9)', width: "24px" }} />
                                    {window.isMobile425 ? '' : <p>  Payments </p>}
                                </NavLink>
                            </IconButton>
                            <IconButton color="inherit">
                                <NavLink to="/app/profile">
                                    <img src={User} />
                                    {window.isMobile425 ? '' : <p>  Profile </p>}
                                </NavLink>
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                </div>
                : ''}
        </div>
    );
}
export default withSnackbar(Layout);
